import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/ui/components/Button';
import { ToggleSwitchCard } from '@/ui/components/ToggleSwitchCard';
import { Icon } from '@/ui/icons/Icon';
import { checkMarkButton } from '@/assets/images/emojis';
import { useTerms } from '@/features/terms/hooks/useTerms';
import { useOnboarding } from '@/features/onboarding';
import { routes } from '@/routes/routes';
import { useError } from '@/providers/Error';
import { genericMessages } from '@/constants/errorMessages';
import styles from './BcConsentPage.module.scss';

// BC consent only: ANAF consent is asked later, when the user activates the
// preliminary offer.
export function BcConsentPage() {
  const navigate = useNavigate();
  const { setError } = useError();
  const { acceptBcTerms, isLoading } = useTerms();
  const { getOnboardingState } = useOnboarding();
  const [isAccepted, setIsAccepted] = useState(false);

  const handleContinue = async () => {
    try {
      await acceptBcTerms();
      await getOnboardingState();
      navigate(routes.scoring.base);
    } catch {
      setError(genericMessages.unexpected);
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.emojiContainer}>
            <img
              src={checkMarkButton}
              alt="Confirm agreement"
              className={styles.emoji}
            />
          </div>
          <div className={styles.textContainer}>
            <h1 className={styles.title}>Hai să-ți calculăm oferta</h1>
            <p className={styles.subtitle}>
              Avem nevoie de acordul tău pentru a verifica istoricul tău la
              Biroul de Credit.
            </p>
          </div>
        </div>

        <div className={styles.termsSection}>
          <div className={styles.termsItem}>
            <ToggleSwitchCard
              checked={isAccepted}
              label="Sunt de acord cu interogarea la Biroul de credit"
              onChange={setIsAccepted}
              testId="credit-bureau"
            />
            <div className={styles.linkContainer}>
              <Link to={routes.terms.bc} className={styles.link}>
                Termeni și condiții Biroul de Credit
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <Button
          trackingId="accept_bc_terms"
          variant="filled"
          text="Continuă"
          className={styles.button}
          onClick={handleContinue}
          disabled={!isAccepted || isLoading}
          loading={isLoading}
          rightIcon={<Icon name="arrow-right" />}
        />
      </div>
    </div>
  );
}

export default BcConsentPage;
